import { useState } from "react";
import "./accordian.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFan } from "@fortawesome/free-solid-svg-icons";

function FASQ() {
  const [selected, setSelected] = useState(null);

  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    }

    setSelected(i);
  };

  return (
    <div className="wrapper">
      <div className="accordion">
        <div className="faq-heading">
          <h1>
            <FontAwesomeIcon icon={faFan} spin size="sm" /> FAQS{" "}
          </h1>
        </div>

        {data.map((item, i) => (
          <div>
            <div className="item">
              <div className="title" onClick={() => toggle(i)}>
                <h2>{item.question}</h2>

                <span>{selected === i ? "-" : "+"}</span>
              </div>
              <div className={selected === i ? "content show" : "content"}>
                <div>{item.answer}</div>
                <div>{item.answer2}</div>
                <div>
                {item.answer3}
                </div>
                <div>
                {item.answer4}
                </div>
                <div>
                {item.answer5}
                </div>
                <div>
                  {item.answer6}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const data = [
  {
    question: "About Me",
    answer:
      "😇 Currently Completed my 🧑‍🎓 Graduation (2019-2023) in Bachelor of Technology Specialization in 🧑‍💻 Computer Science and Engineering from 🏛️ Kamrah Institute of Information Technology, Gurgaon Haryana.",
  },
  {
    question: "Steps Of Product Development",
    answer: "(1) 🌱 Planning and analysis:- This phase involves understanding the needs of the client and defining the scope of the project. It also includes researching the target audience and identifying the technologies that will be used to develop the website.",
    answer2: "(2) 🖌️ Design:- This phase involves creating the visual look and feel of the website. It includes designing the layout, choosing colors, fonts, and images, and creating wireframes and mockups.",
    answer3: "(3) 🧑‍💻 Development:- This phase involves writing the code that makes the website work. It includes creating HTML, CSS, JavaScript, React  New Technology code, as well as integrating with databases and other third-party services.",
    answer4: "(4) 🧪 Testing:- This phase involves testing the website to ensure that it is functional and meets the requirements of the client. It includes unit testing, integration testing, and user acceptance testing.",
    answer5: "(5) 🛫 Deployment:- This phase involves making the website available to users. It includes uploading the website to a web server and configuring it for production.",
    answer6: "(6) ⛑️ Maintenance:- This phase involves keeping the website up-to-date and fixing any bugs that are found. It also includes adding new features and content to the website.",
  },
  {
    question: "Why do you like Web Developemnt",
    answer: "I like web development because it is a creative and challenging field. I enjoy the process of coming up with new ideas and then bringing them to life through code. I also like the fact that web development is constantly evolving, which means that there is always something new to learn and finding new ways to solve problems. ",
    answer2:"some of the specific reasons why I like:-",
    answer3:"It is ✨ CREATIVE. I enjoy the challenge of coming up with new ideas and then bringing them to life through code. I like the fact that I can be creative and expressive with my code, and that I can use it to solve problems in new and innovative ways.",
    answer4:"It is 🎯 CHALLENGING. I enjoy the challenge of learning new things and solving problems. I like the fact that web development is a constantly evolving field, which means that there is always something new to learn. ",
    answer5:"It is 🏆 REWARDING. I enjoy the feeling of satisfaction that comes from creating something new and useful. I like the fact that my work can have a positive impact on people's lives, and that I can help to make the world a better place. ",
    answer6:" ",
  },

  {
    question: "What I Do",
    answer:"🎨 DESIGN:- Let's Represent the Brand and Vision. There are Three Pieces Yes, No, WOW",
    answer2:"🧑‍💻 DEVELOP:- He adds certain special hidden recipes and making his websites look enticing.",
    answer3:"🎈 DEPLOY:- If You're Not Online, You Don't Exist.",
    answer4:"Some awesome products for the awesome people, Something he has built.",
  },
];

export default FASQ;
